// F-MOTOR-RESERVAS.3.0.4 — Tema oficial Rede Hospeda para documentos PDF jsPDF.
// Centraliza paleta e carregamento do logo oficial para VOUCHER + RECIBO.
// Fonte dos ativos: /app/frontend/public/brand/ (ver F-MOTOR-RESERVAS.3.0.1).

export const PDF_BRAND = {
  // Paleta oficial — tuples RGB para doc.setFillColor / setTextColor / setDrawColor.
  AZUL: [8, 58, 107],              // #083A6B
  AZUL_PROFUNDO: [5, 43, 80],      // #052B50
  DOURADO: [212, 166, 82],         // #D4A652
  CREME: [245, 241, 232],          // #F5F1E8
  INK: [28, 25, 23],               // #1C1917
  MUTED: [107, 114, 128],          // #6B7280
  SURFACE: [255, 255, 255],
  DIVIDER: [230, 225, 215],

  // Fontes jsPDF (built-in). Montserrat/Open Sans não vêm embutidas no jsPDF;
  // usamos as system fonts padrão (helvetica) com pesos para manter nitidez
  // em impressão. Em F-SAAS.N, incluir Montserrat embutido via jsPDF-AutoTable
  // addFont, se desejado.
  FONT_TITLE: "helvetica",         // peso bold aproxima Montserrat
  FONT_BODY: "helvetica",          // substitui Open Sans em PDF nativo
  FONT_MONO: "courier",

  // Logo para fundo claro (header de recibo/padrão).
  LOGO_URL: "/brand/logo-1024.png",
  // F-FIX.VOUCHER.7.2 — logo monocromático branco para header de fundo escuro (voucher).
  LOGO_DARK_URL: "/brand/logo-white.png",
};

let _logoDataUrlCache = null;
let _logoDarkDataUrlCache = null;

async function _fetchAsDataUrl(url) {
  const res = await fetch(url, { cache: "force-cache" });
  if (!res.ok) throw new Error(`logo HTTP ${res.status}`);
  const blob = await res.blob();
  return await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

// Carrega o logo oficial (fundo claro) como dataURL. Cache em módulo.
export async function loadBrandLogoDataUrl() {
  if (_logoDataUrlCache) return _logoDataUrlCache;
  try {
    _logoDataUrlCache = await _fetchAsDataUrl(PDF_BRAND.LOGO_URL);
    return _logoDataUrlCache;
  } catch (err) {
    console.warn("[pdfBrand] falha ao carregar logo oficial:", err);
    return null;
  }
}

// F-FIX.VOUCHER.7.2 — Carrega o logo branco (fundo escuro) para o header do voucher.
export async function loadBrandLogoDarkDataUrl() {
  if (_logoDarkDataUrlCache) return _logoDarkDataUrlCache;
  try {
    _logoDarkDataUrlCache = await _fetchAsDataUrl(PDF_BRAND.LOGO_DARK_URL);
    return _logoDarkDataUrlCache;
  } catch (err) {
    console.warn("[pdfBrand] falha ao carregar logo escuro:", err);
    return null;
  }
}
